import { Component } from '@angular/core';
import { AuthFacade } from '@ecosure-suite/back-office/auth/data-access-auth';
import { StateService } from '@ecosure-suite/common/util-state-management';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-dashboard',
  templateUrl: './login-core.component.html',
  styleUrls: ['./login-core.component.scss']
})
export class LoginCoreComponent {
  error: string;
  loaded$ = this.authService.loaded$;
  loading$ = this.authService.loading$;
  currentState: string = this.stateService.state;

  constructor(
    private authService: AuthFacade,
    private stateService: StateService
  ) {}

  ngOnInit(){
    sessionStorage.clear();
    localStorage.clear();
  }

  login(authenicate: { username: string; password: string }) {
    this.authService.login(authenicate);
    setTimeout(()=> {
      if (localStorage.getItem('err')) {
        this.error = localStorage.getItem('err');
      }
    }, 500)
    
  }
}
